import type Validator from '../../models/Validator';

const AlphaOnlyValidator: Validator = class {
  static isValid(value, allowWhiteSpace = true) {
    if (value) {
      if (allowWhiteSpace) {
        return /^[A-Za-z\s]*$/i.test(value);
      }

      return /^[A-Za-z]*$/i.test(value);
    }

    return false;
  }

  static getError() {
    return null;
  }
};

export default AlphaOnlyValidator;
